import { useState } from 'react';
import { Icon } from '@/components/ui/Icon';
import type { IconName } from '@/components/ui/Icon';
import { agentApi, type AgentQuickAction } from '@/shared/api/agentApi';
import { resolveQuickActionUrl, type CallContext } from '../lib/quickActions';
import { toast } from '@/components/ui/Toast';

export interface QuickActionsRowProps {
  actions: AgentQuickAction[];
  campaignId: number;
  context: CallContext & { lead_id?: number | null };
}

/**
 * "פעולות מהירות" button row shown during a campaign call. url-actions open a
 * new tab with placeholders filled from the call context; automation-actions
 * POST to the backend runner and toast the result.
 */
export function QuickActionsRow({ actions, campaignId, context }: QuickActionsRowProps) {
  const [running, setRunning] = useState<number | null>(null);
  if (!actions?.length) return null;

  async function run(action: AgentQuickAction, idx: number) {
    if (action.type === 'url') {
      if (!action.url) return;
      window.open(resolveQuickActionUrl(action.url, context), '_blank', 'noopener,noreferrer');
      return;
    }
    if (action.automation_id == null) return;
    setRunning(idx);
    try {
      const res = await agentApi.runQuickAction({
        automation_id: action.automation_id,
        campaign_id: campaignId,
        lead_id: context.lead_id ?? null,
        call_id: context.call_id ?? null,
        phone: context.phone ?? null,
        name: context.name ?? null,
      });
      toast(res?.message ?? 'הפעולה הופעלה', res?.ok === false ? 'danger' : 'ok');
    } catch (e) {
      const msg = (e as { response?: { data?: { message?: string } } })?.response?.data?.message;
      toast(msg ?? 'שגיאה בהפעלת הפעולה', 'danger');
    } finally {
      setRunning(null);
    }
  }

  return (
    <div>
      <div style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)', marginBottom: 6 }}>פעולות מהירות</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {actions.map((a, i) => (
          <button key={i} type="button" className="btn" disabled={running === i} onClick={() => run(a, i)}>
            <Icon name={(a.icon as IconName) || (a.type === 'url' ? 'globe' : 'bolt')} size={14} />
            {running === i ? '…' : a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
